/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Funnel_Pw_Billed_YearlyInputs */

const en_funnel_pw_billed_yearly = /** @type {(inputs: Funnel_Pw_Billed_YearlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Billed $${i?.amount}/yr`)
};

const es_funnel_pw_billed_yearly = /** @type {(inputs: Funnel_Pw_Billed_YearlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Facturado $${i?.amount}/año`)
};

/**
* | output |
* | --- |
* | "Billed ${amount}/yr" |
*
* @param {Funnel_Pw_Billed_YearlyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_pw_billed_yearly = /** @type {((inputs: Funnel_Pw_Billed_YearlyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Pw_Billed_YearlyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_pw_billed_yearly(inputs)
	return en_funnel_pw_billed_yearly(inputs)
});